var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-progress-bar',
    {
      'dp-progress-bar--small': _vm.size === 'small',
      'dp-progress-bar--animated': _vm.animated,
    }
  ]},[_c('div',{staticClass:"dp-progress-bar__inner",style:({ width: _vm.innerWidth })})])}
var staticRenderFns = []

export { render, staticRenderFns }